<template>
  <div class="web-head ">
    <div class=" logo" href="/">
      <router-link to="/index">
        <img class="logo-image" src="https://static.zuiqiangyingyu.cn/wonder-website/images/logo.png">
      </router-link>
    </div>
    <div class="burger" @click="isShow=!isShow">
      <b-icon icon="list"></b-icon>
    </div>
    <div class=" navs" :class="isShow?'shown':''" @click="isShow=!isShow">
      <router-link to="/index" class="nav-item">
        首页
      </router-link>
      <router-link to="/about" class="nav-item">
        关于
      </router-link>
      <a href="https://www.zhipin.com/gongsir/b4a008a6a499944603J92ty9Fw~~.html?ka=all-jobs-top" class="nav-item"  target="_blank">
        人才招聘
      </a>
      <router-link to="/cooperation" class="nav-item">
        联系我们
      </router-link>
      <!--<div class="nav-item lang">-->
      <!--<span class="lang-item">EN</span> | <span class="lang-item active">中文</span>-->
      <!--</div>-->
    </div>
  </div>
</template>

<script>
  export default {
    name: "yw_head",
    data() {
      return {
        isShow: false
      }
    },
    methods: {}
  }
</script>

<style scoped>
  .logo-image {
    width: 3.74rem;
  }

  .navs .nav-item {
    border-radius: 25px;
    color: rgba(250, 124, 0, 1);
    display: block;
    float: left;
    font-size: 16px;
    margin: 0 0 0 30px;
    padding: 0 20px;
    line-height: 28px;
    transition: all .3s ease;
    box-sizing: border-box;
    border: 1px solid rgba(255, 255, 255, 0);
  }

  .navs .nav-item:hover, .nav-item.router-link-active:hover {
    border: 1px solid  rgba(250, 124, 0, 1);
    color: rgba(250, 124, 0, 1);
    background: none;
  }

  .navs .nav-item:first-child {
    margin: 0;
  }

  .navs .nav-item.lang {
    cursor: pointer;
    font-size: 12px;
    border: 1px solid rgba(255, 255, 255, 0);
    margin: 0;
    line-height: 28px;
  }

  .navs .nav-item.lang:hover {
    border: 1px solid rgba(255, 255, 255, 0);
    color: #333;
  }

  .navs .nav-item.lang .lang-item {
    opacity: .6;
  }

  .navs .nav-item.lang .lang-item.active {
    opacity: 1;
  }

  .nav-item.router-link-active {
    color: rgba(254, 254, 254, 1);
    background: rgba(250, 124, 0, 1);
  }

  /*.nav-item.router-link-active:hover {*/
    /*border: 1px solid #6EC9F4;*/
    /*color: #6EC9F4;*/
    /*background: none;*/
  /*}*/

  .web-head {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 0.5rem;
    /*box-sizing: border-box;*/
  }

  .burger {
    display: none;
  }


  @media screen and (max-width: 800px) {
    .burger {
      display: block;
    }

    .navs {
      background: rgba(0, 0, 0, .8);
      border-radius: 4px;
      position: fixed;
      right: -160px;
      top: 40px;
      transition: all .3s ease;
      z-index: 9999;
    }

    .navs .nav-item, .navs .nav-item:first-child, .navs .nav-item:hover {
      border: none;
      border-bottom: 1px solid hsla(0, 0%, 100%, .3);
      border-radius: 0;
      float: none;
      font-size: 14px;
      margin: 10px auto;
      padding: 10px 20px;
      box-sizing: border-box;
      text-align: center;
      z-index: 999;
    }

    .navs.shown {
      right: 18px;
    }

    .navs .nav-item {
      display: block;
      color: #fff;
    }

    .navs .nav-item.router-link-active {
      background: none;
      color: #6EC9F4;
    }

    .navs .nav-item.router-link-active:hover {
      color: #6EC9F4;
      background: none;
    }

    .navs .nav-item.lang {
      border: none;
    }

    .navs .nav-item.lang:hover {
      border: none;
      color: #6EC9F4;
    }
  }
</style>




// WEBPACK FOOTER //
// src/components/yw_head.vue